import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function SeventhCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Furtarás "}/>

            <p className="info-text">
                Proíbe tomar ou reter injustamente o bem alheio. <br/> 
                O catecismo ensina que devemos praticar justiça e caridade no uso dos bens terrenos e do fruto do trabalho humano[72]. <br/>
                Ele ressalta o “destino universal dos bens”: tudo que existe foi criado por Deus para benefício de todos[72][73]. <br/>
                A propriedade privada é legítima, mas não anula a obrigação de ajudar o próximo e usar moderadamente nossas posses[74]. <br/>
                Reter o que não é nosso (roubo) é pecado[75]. <br/>
                Isso inclui furtos simples e práticas comerciais injustas (fraude, máfia, corrupção, especulação abusiva)[76]. <br/>
                Obriga também a pagar salários justos, honrar contratos e promessas financeiras[77][78]. <br/>
                O mandamento exige reparar o dano: o ladrão deve restituir o que roubou, mais juros se for caso de lucro obtido indevidamente[79]
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
                No cotidiano, viver este mandamento é ser honesto e justo com os bens próprios e os dos outros.<br/> 
                Significa nunca roubar em sentido estrito, mas também não enganar em negócios: não furtar dinheiro de caixa, não subornar, não plagiar trabalhos intelectuais, não apropriar-se do que é comum (alimentação no trabalho, recursos da empresa) sem permissão. <br/> 
                Pagar impostos devidos, não fraudar a aposentadoria alheia (por exemplo, pagando salários injustos) e não explorar economicamente os outros (precificar produtos de forma abusiva) são exigências deste mandamento[76]. <br/>
                Também ser generoso com quem precisa – não tomar mais do que o justo para si – cumpre sua parte na “destinação universal dos bens”[72][73]. <br/>
                Proteger o meio ambiente, evitando desperdícios e cuidando dos recursos naturais, é forma moderna de respeitar a criação dada a todos[80]. 
                Em resumo: trabalhar honestamente para ganhar o pão de cada dia, ajudar os pobres com caridade e ser justo no comércio.
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
            O sétimo mandamento reflete que tudo é obra de Deus e pertence a Ele em último termo[72]. <br/>
            Somos administradores, não donos absolutos[74]. <br/>
            O desejo de possuir ou explorar os bens alheios contraria a confiança em Deus que provê para todos. <br/>
            O mandamento também destaca a solidariedade natural: a prosperidade de uns não deve ser às custas do outro[73]. <br/>
            O Ciclo Social da Igreja (Doutrina Social) deriva muitos princípios deste mandamento: justiça social, bem comum, caridade, eclesiologia econômica. <br/>
            Por exemplo, promover a dignidade do trabalho e defender direitos do trabalhador (salários justos, descanso) são desdobramentos desse dever moral[81][80]. <br/>
            Ainda, o Catecismo lembra a integridade da criação como parte do respeitar os bens: não se deve destruir arbitrariamente animais, plantas ou recursos vitais[80]. <br/>
            Logo, o mandamento está ligado à mensagem evangélica da “irmandade” entre os homens, condenando tanto a avareza quanto a inveja (ver também 10º mandamento) e chamando ao desapego cristão.
            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}